import { useEffect } from "react";
import { useAuthContext } from "../context/authContext";
import { SupportedLanguages, UILanguageCode } from "../types";

export const useIubenda = () => {
  const auth = useAuthContext();

  useEffect(() => {
    // Don't inject while loading
    if (auth.isLoading) {
      return;
    }

    // Determine language after loading is complete
    const language: UILanguageCode = auth.identity?.language ?? (navigator.language.substring(0, 2) as UILanguageCode);
    const lang = SupportedLanguages.includes(language) ? language : "en";

    document.documentElement.lang = lang;

    // Inject Iubenda scripts
    const widgetScript = document.createElement("script");
    widgetScript.id = "iubenda-widget-script";
    widgetScript.type = "text/javascript";
    widgetScript.src = "https://embeds.iubenda.com/widgets/7080fd91-9aac-48f0-922b-8bfbb51b366b.js";

    const initScript = document.createElement("script");
    initScript.id = "iubenda-init-script";
    initScript.type = "text/javascript";
    initScript.text = [
      "var _iub = _iub || {};",
      "_iub.cons_instructions = _iub.cons_instructions || [];",
      `_iub.cons_instructions.push(["init", { api_key: "${import.meta.env.IUBENDA_API_KEY}" }]);`,
    ].join("\n");

    const consScript = document.createElement("script");
    consScript.id = "iubenda-cons-script";
    consScript.type = "text/javascript";
    consScript.src = "https://cdn.iubenda.com/cons/iubenda_cons.js";
    consScript.async = true;

    document.head.appendChild(widgetScript);
    document.head.appendChild(initScript);
    document.head.appendChild(consScript);
  }, [auth.isLoading, auth.identity?.language]);
};
